<template>
    <div :class="['main-content-article', 'article_' + article.id_web_content]">
        <div v-html="article.html"></div>
    </div>
</template>

<script>
import { mapState } from "vuex"

export default {
    computed: {
        ...mapState(["ContentStore"])
    },
    data() {
        return {
            article: {
                id_web_content: null,
                title: null,
                alias: null,
                html: null
            }
        }
    },
    watch: {
        $route(to, from) {
            this.args = core.getPathArgs(["id"])
            this.loadArticle()
        }
    },
    mounted() {
        this.args = core.getPathArgs(["id"])
        if (this.args.id === undefined && this.ContentStore.find(item => item.title == "Willkommen") !== undefined) {
            this.args.id = this.ContentStore.find(item => item.title == "Willkommen").id_web_content
        }
        if (this.ContentStore.find(item => item.id_web_content == this.args.id || item.alias == this.args.id) === undefined) {
            this.article = {
                id_web_content: 0,
                title: "",
                alias: "",
                html: "Willkommen..."
            }
        } else {
            this.loadArticle()
        }
        core.on("content-finished", this.loadArticle)
    },
    destroyed() {
        core.off(this.loadArticle, "content-finished")
    },
    methods: {
        loadArticle() {
            if (this.args.id === undefined) {
                this.args.id = this.ContentStore.find(item => item.title == "Willkommen").id_web_content
            }
            this.article = this.ContentStore.find(item => item.id_web_content == this.args.id || item.alias == this.args.id)
        }
    }
}
</script>

<style lang="scss" scoped>
</style>